// Lumina Theme — theme.js

document.addEventListener('DOMContentLoaded', () => {

  // ── Header scroll shadow ──────────────────────────────────
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('scrolled', window.scrollY > 40);
    }, { passive: true });
  }

  // ── Mobile navigation ─────────────────────────────────────
  const hamburger = document.querySelector('.hamburger');
  const mobileNav = document.querySelector('.mobile-nav');
  const mobileOverlay = document.querySelector('.mobile-overlay');
  const mobileClose = document.querySelector('.mobile-nav__close');

  function openNav() {
    mobileNav?.classList.add('is-open');
    mobileOverlay?.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    hamburger?.setAttribute('aria-expanded', 'true');
  }
  function closeNav() {
    mobileNav?.classList.remove('is-open');
    mobileOverlay?.classList.remove('is-open');
    document.body.style.overflow = '';
    hamburger?.setAttribute('aria-expanded', 'false');
  }

  hamburger?.addEventListener('click', openNav);
  mobileClose?.addEventListener('click', closeNav);
  mobileOverlay?.addEventListener('click', closeNav);

  // ── Header search ─────────────────────────────────────────
  const searchToggle = document.querySelector('.header-search-toggle');
  const searchPanel = document.querySelector('#HeaderSearch');
  const searchInput = searchPanel?.querySelector('.header-search__input');
  const searchClose = searchPanel?.querySelector('.header-search__close');

  function openSearch() {
    if (!searchPanel) return;
    searchPanel.hidden = false;
    searchPanel.classList.add('is-open');
    searchToggle?.setAttribute('aria-expanded', 'true');
    searchInput?.focus();
  }
  function closeSearch() {
    if (!searchPanel || searchPanel.hidden) return;
    closeSuggestions();
    searchPanel.hidden = true;
    searchPanel.classList.remove('is-open');
    searchToggle?.setAttribute('aria-expanded', 'false');
    searchToggle?.focus();
  }

  searchToggle?.addEventListener('click', () => {
    searchPanel?.hidden ? openSearch() : closeSearch();
  });
  searchClose?.addEventListener('click', closeSearch);
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') closeSearch();
  });

  // ── Predictive search (sugerencias en vivo) ───────────────
  const searchForm = searchPanel?.querySelector('.header-search__form');
  const suggestBox = document.querySelector('#PredictiveSearchResults');
  const suggestStatus = document.querySelector('#PredictiveSearchStatus');
  const suggestUrl = searchForm?.dataset.suggestUrl;
  const suggestCache = new Map();
  let suggestTimer;
  let suggestController;
  let activeIndex = -1;

  function suggestOptions() {
    return suggestBox ? [...suggestBox.querySelectorAll('[role="option"]')] : [];
  }
  function setActive(index) {
    const options = suggestOptions();
    options.forEach(o => o.setAttribute('aria-selected', 'false'));
    activeIndex = index;
    const current = options[index];
    if (current) {
      current.setAttribute('aria-selected', 'true');
      current.scrollIntoView({ block: 'nearest' });
      searchInput.setAttribute('aria-activedescendant', current.id);
    } else {
      searchInput.removeAttribute('aria-activedescendant');
    }
  }
  function closeSuggestions() {
    if (!suggestBox) return;
    clearTimeout(suggestTimer);
    suggestController?.abort();
    suggestBox.hidden = true;
    suggestBox.classList.remove('is-loading');
    searchInput?.setAttribute('aria-expanded', 'false');
    setActive(-1);
  }
  function showSuggestions(html) {
    suggestBox.innerHTML = html;
    suggestBox.hidden = false;
    suggestBox.classList.remove('is-loading');
    searchInput.setAttribute('aria-expanded', 'true');
    setActive(-1);
    const results = suggestBox.querySelector('.predictive-search__results');
    const count = Number(results?.dataset.count || 0);
    if (suggestStatus) {
      suggestStatus.textContent = count
        ? `${count} sugerencia${count === 1 ? '' : 's'} disponibles`
        : 'Sin resultados';
    }
  }

  async function fetchSuggestions(q) {
    if (suggestCache.has(q)) return showSuggestions(suggestCache.get(q));
    suggestController?.abort();
    suggestController = new AbortController();
    suggestBox.classList.add('is-loading');
    const params = new URLSearchParams({
      q,
      section_id: 'predictive-search',
      'resources[type]': 'query,product,collection',
      'resources[limit]': '10',
      'resources[limit_scope]': 'each',
      'resources[options][fields]': 'title,product_type,vendor,tag,variants.sku,variants.title'
    });
    try {
      const res = await fetch(`${suggestUrl}?${params}`, { signal: suggestController.signal });
      if (!res.ok) throw new Error(res.status);
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const html = doc.querySelector('#shopify-section-predictive-search')?.innerHTML || '';
      suggestCache.set(q, html);
      // Si el usuario siguió escribiendo, no pintar resultados viejos
      if (searchInput.value.trim() === q) showSuggestions(html);
    } catch (err) {
      if (err.name !== 'AbortError') closeSuggestions();
    }
  }

  if (searchInput && suggestBox && suggestUrl) {
    searchInput.addEventListener('input', () => {
      const q = searchInput.value.trim();
      clearTimeout(suggestTimer);
      if (q.length < 2) return closeSuggestions();
      suggestTimer = setTimeout(() => fetchSuggestions(q), 250);
    });

    searchInput.addEventListener('focus', () => {
      const q = searchInput.value.trim();
      if (q.length >= 2 && suggestCache.has(q)) showSuggestions(suggestCache.get(q));
    });

    searchInput.addEventListener('keydown', e => {
      const open = !suggestBox.hidden;
      const options = suggestOptions();
      if (e.key === 'ArrowDown' && open && options.length) {
        e.preventDefault();
        setActive(activeIndex < options.length - 1 ? activeIndex + 1 : 0);
      } else if (e.key === 'ArrowUp' && open && options.length) {
        e.preventDefault();
        setActive(activeIndex > 0 ? activeIndex - 1 : options.length - 1);
      } else if (e.key === 'Enter' && open && options[activeIndex]) {
        e.preventDefault();
        window.location.href = options[activeIndex].href;
      } else if (e.key === 'Escape' && open) {
        // Primer Escape cierra las sugerencias; el segundo cierra la barra
        e.stopPropagation();
        closeSuggestions();
      }
    });

    document.addEventListener('click', e => {
      if (!suggestBox.hidden && !searchPanel.contains(e.target)) closeSuggestions();
    });
  }

  // ── Product gallery thumbnails ────────────────────────────
  const thumbs = document.querySelectorAll('.product-page__thumb');
  const mainImg = document.querySelector('#MainProductImage');

  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      thumbs.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      if (mainImg) {
        const src = thumb.dataset.fullSrc || thumb.querySelector('img')?.src;
        if (src) {
          // The main image has a `srcset`, which browsers prioritize over `src`.
          // Remove it so the clicked thumbnail's image actually takes effect.
          mainImg.removeAttribute('srcset');
          mainImg.removeAttribute('sizes');
          mainImg.src = src;
        }
      }
    });
  });

  // ── Quantity selectors ────────────────────────────────────
  document.querySelectorAll('.quantity-selector').forEach(sel => {
    const input = sel.querySelector('.quantity-selector__input');
    const minus = sel.querySelector('[data-action="minus"]');
    const plus = sel.querySelector('[data-action="plus"]');
    if (!input) return;
    minus?.addEventListener('click', () => {
      const v = parseInt(input.value) || 1;
      if (v > 1) input.value = v - 1;
    });
    plus?.addEventListener('click', () => {
      const v = parseInt(input.value) || 1;
      const max = parseInt(input.max) || Infinity;
      if (v < max) input.value = v + 1;
    });
  });

  // ── Variant buttons ───────────────────────────────────────
  document.querySelectorAll('.variant-options').forEach(group => {
    group.querySelectorAll('.variant-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        group.querySelectorAll('.variant-btn').forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
      });
    });
  });

  // ── Hero particles ────────────────────────────────────────
  const particleContainer = document.querySelector('.hero__particles');
  if (particleContainer) {
    for (let i = 0; i < 18; i++) {
      const p = document.createElement('div');
      p.className = 'hero__particle';
      p.style.cssText = `
        left: ${Math.random() * 100}%;
        bottom: -10px;
        animation-duration: ${6 + Math.random() * 10}s;
        animation-delay: ${Math.random() * 8}s;
        opacity: ${0.3 + Math.random() * 0.5};
        width: ${1 + Math.random() * 2}px;
        height: ${1 + Math.random() * 2}px;
      `;
      particleContainer.appendChild(p);
    }
  }

  // ── Mobile submenu toggles ────────────────────────────────
  document.querySelectorAll('.mobile-nav__parent').forEach(btn => {
    btn.addEventListener('click', () => {
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      const childrenId = btn.getAttribute('aria-controls');
      const children = document.getElementById(childrenId);
      btn.setAttribute('aria-expanded', String(!expanded));
      children?.classList.toggle('is-open', !expanded);
    });
  });

  // ── Sort by select redirect ───────────────────────────────
  const sortSelect = document.querySelector('#SortBy');
  sortSelect?.addEventListener('change', () => {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', sortSelect.value);
    window.location.href = url.toString();
  });

  // ── Formularios de Contacto/Cotizaciones → Google Sheets ──
  // Envía una copia de cada envío al Apps Script vía sendBeacon.
  // Se escucha el click del botón (no el "submit" del form) porque
  // Shopify agrega un hCaptcha invisible al formulario de contacto que
  // termina llamando a form.submit() de forma programática — ese método
  // no dispara el evento "submit" del navegador, así que un listener ahí
  // nunca se ejecutaría. El click del botón sí ocurre siempre, antes de
  // cualquier verificación de captcha.
  const SHEETS_ENDPOINT = 'https://script.google.com/macros/s/AKfycbxSeA2b5HRo7lD-uyYyKivDPHw_2oRp2saZB13oJVRziKmuwWj_yzliXPDFL_k8TIbcAw/exec';
  const SHEETS_TOKEN = '892ejifvjjsfd98fSDFEI3#-sfg';

  document.querySelectorAll('form[action*="/contact"] button[type="submit"]').forEach(boton => {
    boton.addEventListener('click', () => {
      const form = boton.closest('form');
      if (!form) return;

      const datos = { token: SHEETS_TOKEN };
      form.querySelectorAll('[name^="contact["]').forEach(campo => {
        const match = campo.name.match(/^contact\[(.+)\]$/);
        if (match) datos[match[1]] = campo.value;
      });

      const blob = new Blob([JSON.stringify(datos)], { type: 'text/plain;charset=utf-8' });
      navigator.sendBeacon(SHEETS_ENDPOINT, blob);
    });
  });

});
